import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  MotifButton,
  MotifDropdown,
  MotifDropdownItem,
  MotifIcon,
} from '@ey-xd/motif-react';
import { IconoirNavArrowDown } from '@ey-xd/motif-icon';

const MasterDataManagementHeader = ({
  handleAddGroups,
  handleExportGroupImportTemplate,
  handleUploadGroupImportTemplate,
  handleDownloadMasterDataReport,
}) => {
  const [actionOptionsOpen, setActionOptionsOpen] = useState(false);

  return (
    <div className="row mt-3">
      <div className="col-md-2"> </div>
      <div className="col-md-10 d-flex justify-content-end">
        <div style={{ width: 'fit-content' }}>
          <MotifDropdown
            open={actionOptionsOpen}
            placement="bottom-end"
            id={'action-dropdown'}
            className="master-data-dropdown-action"
            handleClickOutside={() => setActionOptionsOpen(false)}
            trigger={
              <MotifButton
                type="button"
                variant="primary"
                onClick={() => setActionOptionsOpen(!actionOptionsOpen)}
                aria-controls={'action-dropdown'}
                id={'action-dropdown-trigger'}
                aria-expanded={actionOptionsOpen}
                aria-label="Action dropdown"
                data-testid="btnActions"
              >
                Actions{' '}
                <MotifIcon
                  iconFunction={IconoirNavArrowDown}
                  size="24"
                  fill="none"
                />
              </MotifButton>
            }
          >
            <ul role="menu">
              <li role="menuitem">
                <MotifDropdownItem
                  type="button"
                  onClick={handleAddGroups}
                  data-testid="btnAddGroup"
                  className="master-dropdown-item"
                >
                  Add Group
                </MotifDropdownItem>
              </li>
              <li role="menuitem">
                <MotifDropdownItem
                  type="button"
                  onClick={handleExportGroupImportTemplate}
                  data-testid="btnExportGroupImportTemplate"
                  className="master-dropdown-item"
                >
                  Export Group Import Template
                </MotifDropdownItem>
              </li>
              <li role="menuitem">
                <MotifDropdownItem
                  type="button"
                  onClick={handleUploadGroupImportTemplate}
                  data-testid="btnUploadGroupImportTemplate"
                  className="master-dropdown-item"
                >
                  Upload Group Import Template
                </MotifDropdownItem>
              </li>
              <li role="menuitem">
                <MotifDropdownItem
                  type="button"
                  onClick={handleDownloadMasterDataReport}
                  data-testid="btnDownloadMasterDataReport"
                  className="master-dropdown-item"
                >
                  Download - Master Data Report (All Types)
                </MotifDropdownItem>
              </li>
            </ul>
          </MotifDropdown>
        </div>
      </div>
    </div>
  );
};

MasterDataManagementHeader.propTypes = {
  handleAddGroups: PropTypes.func.isRequired,
  handleExportGroupImportTemplate: PropTypes.func.isRequired,
  handleUploadGroupImportTemplate: PropTypes.func.isRequired,
  handleDownloadMasterDataReport: PropTypes.func.isRequired,
};

export default MasterDataManagementHeader;
